import { useQuery } from '@tanstack/react-query';
import { fetchPluginsByIds, fetchPluginsByPluginName } from '@api/marketplace';
import { formatApiError } from '@api/common/errors';
import { toPluginModel } from '@common/queries/plugins/to-plugin-model';
import auth from '@common/auth/auth';
import { getQueryAlertMessages } from '../formatters/alerts';
const keys = {
    all: ['marketplace-plugins'],
    list: (xmlIds) => ['marketplace-plugins', 'list', xmlIds],
    filtered: (filter) => ['marketplace-plugins', 'filtered', filter]
};
export function useOriginalMarketplacePlugins(xmlIds, enabled) {
    var _a;
    return useQuery({
        queryKey: keys.list(xmlIds),
        queryFn: () => fetchPluginsByIds(xmlIds),
        enabled: ((_a = auth.getUserProfile()) === null || _a === void 0 ? void 0 : _a.role) === 'ADMIN' && enabled,
        placeholderData: [],
        staleTime: Infinity,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load marketplace plugins'))
    });
}
export function useMarketplacePlugins(xmlIds, enabled) {
    return useQuery({
        queryKey: keys.list(xmlIds),
        queryFn: () => fetchPluginsByIds(xmlIds),
        staleTime: Infinity,
        placeholderData: [],
        enabled,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load marketplace plugins')),
        select: data => data.map(plugin => toPluginModel(plugin.xmlId, 'MARKETPLACE', plugin.name))
    });
}
export function useOriginalFilteredMarketplacePlugins(filter, enabled = true) {
    return useQuery({
        queryKey: keys.filtered(filter),
        queryFn: () => fetchPluginsByPluginName(filter),
        enabled,
        placeholderData: [],
        staleTime: Infinity,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to search marketplace plugins'))
    });
}
export function useSearchMarketplacePlugins(filter, enabled = true) {
    return useQuery({
        queryKey: keys.filtered(filter),
        queryFn: () => fetchPluginsByPluginName(filter),
        select: data => data.map(plugin => toPluginModel(plugin.xmlId, 'MARKETPLACE', plugin.name)),
        placeholderData: [],
        staleTime: Infinity,
        enabled,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to search marketplace plugins'))
    });
}
